"use strict";

exports.__esModule = true;
exports.ElementEditorContext = void 0;
var _Utils = require("../../../../Utils");
/**
 * Provides element editor controller to consumers.
 * @component
 */
var ElementEditorContext = exports.ElementEditorContext = (0, _Utils.createEnhancedContext)({
  propName: "elementEditor"
});